import { render } from "./SelectPaymentMethod.vue?vue&type=template&id=8ccd0d34"
import script from "./SelectPaymentMethod.vue?vue&type=script&lang=js"
export * from "./SelectPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__